import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { TickCircle } from "iconsax-react";

import { Button } from "@/shared/components/ui/Button";
import { BrandWordmark } from "@/shared/components/branding/BrandWordmark";
import { resetPasswordReset } from "@/features/auth/store/passwordReset.store";

export function ForgotPasswordSuccessPage() {
  const navigate = useNavigate();
  const { t } = useTranslation("auth");

  useEffect(() => {
    resetPasswordReset();
  }, []);

  return (
    <div className="flex min-h-[100svh] flex-col items-center bg-[#c9cdd3] px-6 py-10">
      <div className="flex w-full justify-center">
        <BrandWordmark />
      </div>

      <div className="mt-14 flex w-full max-w-[28rem] flex-col items-center rounded-md bg-surface-card px-8 py-10 text-center shadow-card">
        <div
          className="mb-6 flex items-center justify-center text-[#22c266]"
          aria-hidden="true"
        >
          <TickCircle size={48} variant="Linear" color="currentColor" />
        </div>
        <h1 className="m-0 text-[1.5rem] leading-tight font-bold text-text-primary">
          {t("auth:forgotPassword.success.title")}
        </h1>
        <p className="mt-4 text-sm leading-6 text-text-muted">
          {t("auth:forgotPassword.success.description")}
        </p>
        <div className="mt-8 w-full">
          <Button
            className="min-h-9 px-5 py-1.5 text-sm bg-[#1FC16B]! hover:bg-[#189A5A]! active:bg-[#189A5A]! text-white!"
            onClick={() => navigate("/login")}
          >
            {t("auth:forgotPassword.success.btn.login")}
          </Button>
        </div>
      </div>
    </div>
  );
}
